import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserAccountDto } from './api-client/models';

@Injectable({
  providedIn: 'root'
})
export class UserStoreService {

  public user: Subject<UserAccountDto> = new Subject<UserAccountDto>();
  private loggedIn: boolean = false;
  private technicalAdmin = false;
  private businessAdmin = false;

  storeUser(user: UserAccountDto) {
    this.loggedIn = true;
    this.user.next(user);
    this.businessAdmin = user.businessAdmin;
    this.technicalAdmin = user.technicalAdmin;
  }

  isTechnicalAdmin(): boolean {
    return this.technicalAdmin;
  }

  isBusinessAdmin(): boolean {
    return this.businessAdmin;
  }

  getUser(): Observable<UserAccountDto> {
    return this.user.asObservable();
  }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

}
